
import { Component, Mixins } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import { namespace } from "vuex-class";
import vselect3 from "vselect3";

import AlarmActionsMixin from "@/mixins/AlarmActionsMixin";
import { ServerDetails } from "@/store/devices/types";
import { Response } from "@/store/responses/types";
import { NotificationMessageTemplate } from "@/store/tasks/types";

const Responses = namespace("responses");
const Tasks = namespace("tasks");

@Component({
	components: {
		"v-select-3": vselect3
	},
	validations: {
		currentAlarmAction: { objectID: { required } },
		hasDataChanged: {
			required: requiredIf(function() {
				return this.currentAlarmAction.objectID === this.originalObjectId;
			})
		}
	}
})
export default class ActionSetupSendNotification extends Mixins(AlarmActionsMixin, validationMixin) {
	@Responses.State private currentAlarm: Response;
	@Tasks.Action private fetchNotificationServersByGroup: (groupId: number) => Promise<void>;
	@Tasks.Action private fetchNotificationTemplates: (serverId: number) => Promise<void>;
	@Tasks.Action private fetchTemplateDetails: (notificationsMessageTemplateID: number) => Promise<void>;
	@Tasks.State private NotificationServers: ServerDetails;
	@Tasks.State private NotificationTemplate: NotificationMessageTemplate;
	@Tasks.State private NotificationTemplates: NotificationMessageTemplate[];

	private deviceId: number = null;
	private originalObjectId: number = null;

	public async created(): Promise<void> {
		await this.fetchNotificationServersByGroup(this.currentAlarm.groupID);

		if (this.isEditing) {
			await this.fetchTemplateDetails(this.currentAlarmAction.objectID);
			this.deviceId = this.NotificationTemplate.serverID;

			await this.fetchNotificationTemplates(this.deviceId);
			this.originalObjectId = this.currentAlarmAction.objectID;
		}
	}

	private async handleDeviceSelected(): Promise<void> {
		//Need to check it is already defined, as if it is already undefined,
		//vuelidate bugs and will never pass validation
		if (this.currentAlarmAction.objectID) {
			this.currentAlarmAction.objectID = undefined;
		}

		if (this.deviceId) {
			await this.fetchNotificationTemplates(this.deviceId);
			return;
		}
	}
}
